import { ButtonGroup, Col, Input, Label } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { OptionOne, OptionTwo } from "../../../../Constant";
import { RADIO_BUTTON_LIST } from "../../../../Data/Buttons/ButtonGroup";
import { ButtonGroupProp } from "../../../../Type/Buttons";

export const DynamicRadioButtonGroup = () => {
  return (
    <>
      {RADIO_BUTTON_LIST.map(({ idOne, color, idTwo, name }: ButtonGroupProp, index) => (
        <Col xl="4" md="6" sm="12" key={index}>
          <div className="btn-radio">
            <ButtonGroup>
              <Btn color={color}>
                <div className={`radio radio-${color}`}>
                  <Input id={`radio${idOne}`} type="radio" name={name} />
                  <Label htmlFor={`radio${idOne}`}>{OptionOne}</Label>
                </div>
              </Btn>
              <Btn color={color}>
                <div className={`radio radio-${color}`}>
                  <Input id={`radio${idTwo}`} type="radio" name={name} />
                  <Label htmlFor={`radio${idTwo}`}>{OptionTwo}</Label>
                </div>
              </Btn>
            </ButtonGroup>
          </div>
        </Col>
      ))}
    </>
  );
};
